import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useCallback, useEffect, useRef, useState } from "react";
import { setColumnWidth } from "../../../helpers/cookieUtils";
import ListingHeader from "../listingHeader/ListingHeader";
import {
  Tooltip,
  TableCellLayout,
  Popover,
  PopoverTrigger,
  PopoverSurface,
  makeStyles,
} from "@fluentui/react-components";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import useNavigation from "../../../utils/useNavigation";
import {
  AttachementIcon,
  DeleteIcon,
  EditIcon,
  FlagIcon,
  MeatBallsMenuIcon,
  PendingDeleteIcon,
  RemindIcon,
} from "../../../modules/default-svg";
import userService from "../../../store/services/user.service";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { generalActions } from "../../../store/actions";
import CustomSelect from "../select/CustomSelect";
import Spin from "../spinner/Spin";
import clientService from "../../../store/services/clients.service";
import { apiCall } from "../../../store/services/service";
import {
  BASE_URL,
  URL_SEARCH_CLIENT_PORTFOLIO,
} from "../../../store/services/URL";
import {
  createCommunicationPlanRequest,
  updateCommunicationFlag,
  updateCommunicationPlanRequest,
} from "../../../store/actions/communications.actions";
import {
  communicationCategoryOptions,
  compareArrays,
  formatDateString,
  formatSequenceNumber,
  formatTime,
  getDeletePermission,
  getEditPermission,
  getLabelByType,
  sortColumnsByOrderlist,
} from "../../../helpers/utils";
import {
  isValidDate,
  localDateFormatted,
  localDateToISODateString,
  utcToLocalDateString,
  utcToLocalDateTimeString,
  utcToLocalTimeString,
} from "../../../utils/systemSettings";
import TableCellSafeHtml from "../../safeHtml/TableCellSafeHtml";
import { createSkeletonRows, useTableContextChange } from "./utils/tableUtils";

const EditInput = ({
  label,
  value,
  onChange,
  type,
  onBlur,
  dateFormat,
  clientId,
  portfolioId,
  programId,
  table,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [resources, setResources] = useState([]);
  const [clients, setClients] = useState([]);
  const [portfolioOptions, setPortfolioOptions] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [dropdownOptions, setDropdownOptions] = useState([]);

  const formatValue = (val) => {
    if (!val) return null;
    if (val.label && val.value) return val;
    return { label: val.name, value: val.id };
  };

  const handleDateChange = (newDate) => {
    if (isValidDate(newDate)) {
      const newValue = localDateToISODateString(newDate);
      setInputValue(newValue);
      onChange(newValue);
    }
  };

  const searchHandler = (value) => {
    if (value === "") {
      setResources([]);
      return;
    }
    userService
      .searchUserDataRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setResources(transformedArray);
      })
      .catch(() => {
        setResources([]);
      });
  };
  const searchClientHandler = (value) => {
    if (value === "") {
      setClients([]);
      return;
    }
    clientService
      .searchClientsRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setClients(transformedArray);
      })
      .catch(() => {
        setClients([]);
      });
  };
  const searchPortfolioHandler = (value) => {
    if (value === "") {
      setPortfolioOptions([]);
      return;
    }
    let queryParam = `?clientId=${clientId}&searchTerm=${value}`;
    apiCall
      .get({
        url: `${URL_SEARCH_CLIENT_PORTFOLIO}${queryParam}`,
        isAuthToken: true,
      })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPortfolioOptions(transformedArray);
      })
      .catch(() => {
        setPortfolioOptions([]);
      });
  };
  const searchProgramHandler = (value) => {
    if (value === "") {
      setPrograms([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    queryParam = queryParam + `clientId=${clientId}&portfolioId=${portfolioId}`;

    apiCall
      .get({ url: `${BASE_URL}search/Programs${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPrograms(transformedArray);
      })
      .catch(() => {
        setPrograms([]);
      });
  };
  const searchProjectHandler = (value) => {
    if (value === "") {
      setProjectOptions([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    queryParam =
      queryParam + `&portfolioId=${portfolioId}&programId=${programId}`;

    apiCall
      .get({ url: `${BASE_URL}search/Projects${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          start: obj.startDate,
          end: obj.endDate,
          label: obj.name,
          value: obj.id,
        }));
        setProjectOptions(transformedArray);
      })
      .catch(() => {
        setProjectOptions([]);
      });
  };

  const dropdownHandler = () => {
    if (label === "Category") {
      setDropdownOptions(() =>
        communicationCategoryOptions.map((item) => ({
          label: item.name,
          value: item.value,
        }))
      );
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const creatingRowState = table.getState().creatingRow;
      if (table?.options?.onCreatingRowSave && creatingRowState) {
        const currentValues = {
          ...creatingRowState.values,
        };
        table.options.onCreatingRowSave({
          values: currentValues,
          table,
        });
      }
    }
  };

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleInputChange = (item) => {
    if (!item) return;
    const newValue = { id: item.value, name: item.label };
    setResources((prev) => [...prev, newValue]);
    onChange(newValue);
  };

  if (type === "text") {
    return (
      <input
        placeholder={`Enter ${label}`}
        defaultValue={inputValue}
        type="text"
        onChange={(e) => onChange(e.target.value)}
        className="Custom-Input"
        onBlur={onBlur}
        onKeyDown={handleKeyDown}
      />
    );
  }

  if (type === "select") {
    let searchTextFunc = searchHandler;
    let options = resources;
    let selectText = "manager";
    if (label === "Client") {
      searchTextFunc = searchClientHandler;
      options = clients;
      selectText = "client";
    } else if (label === "Project") {
      searchTextFunc = searchProjectHandler;
      options = projectOptions;
      selectText = "project";
    } else if (label === "Portfolio") {
      searchTextFunc = searchPortfolioHandler;
      options = portfolioOptions;
      selectText = "portfolio";
    } else if (label === "Program") {
      searchTextFunc = searchProgramHandler;
      options = programs;
      selectText = "program";
    } else if (label === "Project") {
      searchTextFunc = searchProjectHandler;
      options = projectOptions;
      selectText = "project";
    } else if (label === "Category") {
      searchTextFunc = dropdownHandler;
      options = dropdownOptions;
      selectText = "category";
    }

    return (
      <div className="d-flex align-items-center w-full max-w-md mx-auto">
        <CustomSelect
          searchText={searchTextFunc}
          SelectText={selectText}
          CustomClass="ModalAvatarSearch CustomSelect"
          options={options}
          value={formatValue(value)}
          onChange={handleInputChange}
          creatable={false}
          setCreated={handleInputChange}
          handleBlur={onBlur}
          isDatatable
          selectWd="w-100"
          onKeyDown={handleKeyDown}
        />
      </div>
    );
  }

  return (
    <DatePicker
      selected={inputValue ? moment(inputValue).toDate() : null}
      onChange={handleDateChange}
      dateFormat={dateFormat}
      className="CustomDatePickerInput"
      onBlur={onBlur}
      popperPlacement="bottom-start"
      placeholderText={dateFormat}
      onKeyDown={handleKeyDown}
      popperClassName="CustomDatePickerPopper"
      showPopperArrow={false}
    />
  );
};

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: "#342c82",
    color: "#FFFFFF",
  },
});

const CommunicationPlanTable = (props) => {
  const {
    columnsList,
    rowData,
    setIsCreate,
    searchHandler,
    tableName,
    handleColumnOrdering,
    dispatch,
    setPageNum,
    perPageItems,
    pagination,
    handleReminder,
    handleEdit,
    handleDelete,
    parentType,
    clientId,
    portfolioId,
    programId,
    projectId,
    cmPlanLoading,
    handleAddRow,
    handleCancelAddRow,
    setRowData,
    isHeader,
    isCalendarView,
    setIsCalendarView,
    triggerSearch,
  } = props;
  const styles = useStyles();
  const [cols, setCols] = useState([]);
  const [rows, setRows] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const setting = JSON.parse(localStorage.getItem("settings"));
  const [editedRows, setEditedRows] = useState({});
  const tableContainerRef = useRef(null);
  const lastScrollTop = useRef(0);
  const selectRefs = useRef({});
  const history = useHistory();
  const { navigateTo } = useNavigation();
  const [editingHeader, setEditingHeader] = useState(null);
  const [headerValue, setHeaderValue] = useState("");
  const [columnSizing, setColumnSizing] = useState({});
  const [columnOrder, setColumnOrder] = useState([]);
  const [sorting, setSorting] = useState([]);
  const [popoverStates, setPopoverStates] = useState({});
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const { hasContextChanged } = useTableContextChange({
    contextValues: {
      clientId,
      portfolioId,
      programId,
      projectId,
      parentType
    },
    setIsFetchingMore,
    setRows,
    setRowData,
  });

  const handlePopoverChange = (itemId, isOpen) => {
    setPopoverStates(isOpen ? { [itemId]: isOpen } : {});
  };
  const [colsList, setColumnsList] = useState([]);
  useEffect(() => {
    if (columnsList.length) {
      setColumnsList(columnsList);
    }
  }, [columnsList]);
  const handleHeaderDoubleClick = (columnId, currentHeader) => {
    setEditingHeader(columnId);
    setHeaderValue(currentHeader);
  };

  const handleHeaderSave = (columnId) => {
    if (!headerValue.trim()) {
      dispatch(
        generalActions.showToast({
          title: "Header name cannot be empty",
          type: "error",
        })
      );
      return;
    }

    const updatedColumnsDB = cols.map((col) => ({
      name: col.Label,
      customName: col.accessorKey === columnId ? headerValue : col.CustomName,
      order: col.Order,
      isVisible: col.Visibility,
    }));

    const payload = {
      Name: tableName,
      Columns: updatedColumnsDB,
    };

    userService
      .putUserLayoutRequest(payload)
      .then(() => { })
      .catch(() => {
        dispatch(
          generalActions.showToast({
            title: "Error updating column header",
            type: "error",
          })
        );
      })
      .finally(() => {
        setColumnsList((prevCols) => {
          const newCols = prevCols.map((col) =>
            col.accessorKey === columnId
              ? { ...col, header: headerValue, customName: headerValue }
              : col
          );
          return newCols;
        });
      });

    setEditingHeader(null);
    setHeaderValue("");
  };

  const handleRedirect = (item) => {
    // Use navigation hook instead of localStorage
    navigateTo("Portfolios", item.id, item.name);
  };

  const handleClientRedirect = (item) => {
    if (parentType !== "Client") {
      // Use navigation hook for direct navigation to client
      navigateTo("Clients", item.client.id, item.client.name);
    } else {
      // Already in client context, just navigate
      history.push(`/clients/${item.client.id}/overview`);
    }
  };

  const handlePortfolioRedirect = (item) => {
    if (item.portfolio) {
      if (parentType !== "Portfolio") {
        // Use navigation hook for direct navigation to portfolio
        navigateTo(
          "Portfolios",
          item.portfolio.id,
          item.portfolio.name,
          "overview"
        );
      } else {
        // Already in portfolio context, just navigate
        history.push(`/portfolio/${item.portfolio.id}/overview`);
      }
    }
  };

  const handleProgramRedirect = (item) => {
    if (item.program) {
      if (parentType !== "Program") {
        // Use navigation hook for direct navigation to program
        navigateTo("Programs", item.program.id, item.program.name);
      } else {
        // Already in program context, just navigate
        history.push(`/program/${item.program.id}/overview`);
      }
    }
  };

  const handleProjectRedirect = (item) => {
    if (item.project) {
      // Use navigation hook for direct navigation to project
      navigateTo("Projects", item.project.id, item.project.name);
    }
  };

  const handleFlag = (id, status) => {
    const newData = [...rowData];
    const index = newData.findIndex((item) => item.id === id);
    if (index !== -1) {
      newData[index].isFlagged = status;
    }

    setRowData(
      newData.sort((a, b) => {
        return b.isFlagged - a.isFlagged;
      })
    );
    dispatch(
      updateCommunicationFlag({
        id: id,
        payload: [
          {
            op: "replace",
            path: "/IsFlagged",
            value: status,
          },
        ],
      })
    );
  };

  const fetchMoreData = useCallback(() => {
    if (!pagination?.HasNext || cmPlanLoading || isFetchingMore || hasContextChanged) return;
    setIsFetchingMore(true);
    setPageNum(pagination.CurrentPage + 1);
  }, [pagination, cmPlanLoading, isFetchingMore, setPageNum, hasContextChanged]);

  useEffect(() => {
    if (!cmPlanLoading && isFetchingMore) {
      setIsFetchingMore(false);
    }
  }, [cmPlanLoading, rowData.length]);

  const fetchMoreOnBottomReached = useCallback(
    (containerRefElement) => {
      if (!containerRefElement || cmPlanLoading || !pagination?.HasNext) return;

      const { scrollHeight, scrollTop, clientHeight } = containerRefElement;
      const scrolledToBottom = Math.abs(scrollHeight - scrollTop - clientHeight) < 50;
      const isScrollingDown = scrollTop > lastScrollTop.current;

      lastScrollTop.current = scrollTop;

      if (isScrollingDown && scrolledToBottom) {
        fetchMoreData();
      }
    },
    [fetchMoreData, cmPlanLoading, pagination]
  );

  const throttledFetchMore = useCallback(
    (() => {
      let timeoutId;
      return (containerRefElement) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          fetchMoreOnBottomReached(containerRefElement);
        }, 100);
      };
    })(),
    [fetchMoreOnBottomReached]
  );

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const handleScroll = () => throttledFetchMore(container);
      container.addEventListener("scroll", handleScroll, { passive: true });
      return () => {
        container.removeEventListener("scroll", handleScroll);
      };
    }
  }, [throttledFetchMore]);

  // Reset scroll position when search is triggered
  useEffect(() => {
    if (tableContainerRef.current && triggerSearch !== undefined) {
      tableContainerRef.current.scrollTop = 0;
      lastScrollTop.current = 0;
    }
  }, [triggerSearch]);

  const formatPayload = (payload) => {
    const formattedPayload = {};
    Object.keys(payload).forEach((key) => {
      formattedPayload[key] = payload[key];
    });
    return formattedPayload;
  };

  const handleSave = (rowId, payload) => {
    const data = { payload };
    if (parentType === "Communications") {
      data.parent = "Communications";
    }
    if (clientId) {
      data.id = clientId;
      data.parent = "Client";
    }
    if (projectId) {
      data.id = projectId;
      data.parent = "Project";
    }
    if (programId) {
      data.id = programId;
      data.parent = "Program";
    }
    if (portfolioId) {
      data.id = portfolioId;
      data.parent = "Portfolio";
    }
    data.sId = rowId;
    dispatch(updateCommunicationPlanRequest(data));
    setEditedRows({});
  };

  const handleCreate = (payload) => {
    const data = { payload };
    data.perPageItems = perPageItems;
    if (parentType === "Communications") {
      data.parent = "Communications";
    }
    if (clientId) {
      data.id = clientId;
      data.parent = "Client";
    }
    if (projectId) {
      data.id = projectId;
      data.parent = "Project";
    }
    if (programId) {
      data.id = programId;
      data.parent = "Program";
    }
    if (portfolioId) {
      data.id = portfolioId;
      data.parent = "Portfolio";
    }
    dispatch(createCommunicationPlanRequest(data));
  };

  const getSortingFunction = (col) => {
    switch (col.label) {
      case "Title":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.title || "").toLowerCase();
          const b = (rowB.original.title || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Sequence #":
        return (rowA, rowB, columnId) => {
          const a = rowA.original.sequenceNumber || 0;
          const b = rowB.original.sequenceNumber || 0;
          return a - b;
        };

      case "Client":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.client?.name || "").toLowerCase();
          const b = (rowB.original.client?.name || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Portfolio":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.portfolio?.name || "").toLowerCase();
          const b = (rowB.original.portfolio?.name || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Program":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.program?.name || "").toLowerCase();
          const b = (rowB.original.program?.name || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Project":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.project?.name || "").toLowerCase();
          const b = (rowB.original.project?.name || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Message":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.message || "").toLowerCase();
          const b = (rowB.original.message || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Audience":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.audience || "").toLowerCase();
          const b = (rowB.original.audience || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Frequency/When":
        return (rowA, rowB, columnId) => {
          const a = new Date(rowA.original.time || 0);
          const b = new Date(rowB.original.time || 0);
          return a.getTime() - b.getTime();
        };

      case "Medium":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.medium || "").toLowerCase();
          const b = (rowB.original.medium || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Source":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.source || "").toLowerCase();
          const b = (rowB.original.source || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Expeditor":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.expeditor || "").toLowerCase();
          const b = (rowB.original.expeditor || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Status":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.status || "").toLowerCase();
          const b = (rowB.original.status || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Purpose/Highlights":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.highlights || "")
            .toLowerCase()
            .replace(/<[^>]*>/g, ""); // Strip HTML tags
          const b = (rowB.original.highlights || "")
            .toLowerCase()
            .replace(/<[^>]*>/g, "");
          return a.localeCompare(b);
        };

      case "Expected Results/ Key Message":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.results || "")
            .toLowerCase()
            .replace(/<[^>]*>/g, ""); // Strip HTML tags
          const b = (rowB.original.results || "")
            .toLowerCase()
            .replace(/<[^>]*>/g, "");
          return a.localeCompare(b);
        };

      case "Category":
        return (rowA, rowB, columnId) => {
          const a = rowA.original.category || 0;
          const b = rowB.original.category || 0;
          return a - b;
        };

      default:
        return "alphanumeric";
    }
  };

  const getSortDescFirst = (col) => {
    const descFirstColumns = [
      "Frequency/When",
      "Medium",
      "Source",
      "Expeditor",
      "Status",
      "Category",
    ];
    return descFirstColumns.includes(col.label);
  };

  useEffect(() => {
    if (!colsList?.length && !rowData.length) return;

    const baseRows = [...rowData];

    if (isFetchingMore && pagination?.HasNext) {
      const skeletonRows = createSkeletonRows();
      setRows([...baseRows, ...skeletonRows]);
    } else {
      setRows(baseRows);
    }
  }, [rowData, isFetchingMore, pagination?.HasNext, colsList]);

  useEffect(() => {
    if (!colsList?.length && !rowData.length) return;
    const columnsOrder = colsList
      .filter((col) => col.isVisible !== false)
      .sort((a, b) => (a.order || 0) - (b.order || 0))
      .map((item) => item.accessorKey);
    setColumnOrder(columnsOrder);
    const columns = colsList
      .filter((col) => col.isVisible !== false)
      .sort((a, b) => (a.order || 0) - (b.order || 0))
      .map((col, index) => {
        return {
          Label: col.label,
          CustomName: col.customName,
          Order: col.order,
          Visibility: col.isVisible,
          accessorKey: col.accessorKey,
          header: col.header,
          enableHiding: true,
          enableColumnActions: false,
          grow: true,
          enableResizing: true,
          size: col.size,
          editVariant: col.columnType,
          enableGlobalFilter: true,
          enableSorting: editingHeader === col.accessorKey ? false : true,
          sortingFn: getSortingFunction(col),
          sortDescFirst: getSortDescFirst(col),
          muiEditTextFieldProps: ({ cell, row }) => ({
            sx: {
              fontFamily: "Figtree-Regular",
              fontSize: "14px",
              padding: "0.5rem",
              maxHeight: "28px",
            },
            required: col.required || false,
            error: !!validationErrors?.[`${row.id}_${cell.column.id}`],
            helperText: validationErrors?.[`${row.id}_${cell.column.id}`],
            onFocus: () =>
              setValidationErrors({
                ...validationErrors,
                [cell.column.id]: undefined,
              }),
            inputRef: (el) => {
              if (col.columnType === "select") {
                selectRefs.current[`${row.id}_${cell.column.id}`] = el;
              }
            },
            onChange: (event) => {
              const newValue = event.target.value;
              setEditedRows((prev) => ({
                ...prev,
                [row.id]: {
                  ...prev[row.id],
                  [cell.column.id]: newValue,
                },
              }));
            },
            onBlur: (event) => {
              const value = event.target.value;
              const validationError =
                col.required && !value ? "Required" : undefined;
              setValidationErrors((prev) => ({
                ...prev,
                [`${row.id}_${cell.column.id}`]: validationError,
              }));
            },
          }),
          Cell: ({ cell, row }) => {
            const item = row.original;
            // Render skeleton for skeleton rows
            if (item.isSkeleton) {
              return (
                <div
                  style={{
                    height: '20px',
                    background: 'linear-gradient(90deg, #e0e0e0 25%, #ECE7FD 50%, #e0e0e0 75%)',
                    backgroundSize: '200% 100%',
                    animation: 'shimmer 1.5s infinite',
                    borderRadius: '4px',
                    width: '100%'
                  }}
                />
              );
            }
            switch (col.label) {
              case "Title":
                return (
                  <div className="d-flex justify-content-between align-items-center inputWidth">
                    <div className="d-flex align-items-center inputWidth">
                      <Tooltip
                        positioning="before"
                        content={{
                          children: item.isFlagged ? "Unflag" : "Flag",
                          className: styles.tooltip,
                        }}
                        relationship="label"
                        withArrow
                      >
                        <span
                          className={`flag ${item.isFlagged ? "flagActive" : ""
                            }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleFlag(item.id, !item.isFlagged);
                          }}
                        >
                          <FlagIcon />
                        </span>
                      </Tooltip>
                      <span
                        className="d-flex w-full text-truncate"
                        onClick={() => handleEdit(item)}
                      >
                        {item.attachementsCount > 0 && (
                          <div className="mr-1">
                            <AttachementIcon count={item.attachementsCount} />
                          </div>
                        )}
                        {item.isPendingDelete && (
                          <div className="mr-1">
                            <PendingDeleteIcon />
                          </div>
                        )}
                        {item.title}
                      </span>
                      <div className="meatballs-trigger">
                        <Popover
                          open={popoverStates[item.id]}
                          onOpenChange={(e, data) => handlePopoverChange(item.id, data.open || false)}
                          positioning="below-start"
                        >
                          <PopoverTrigger disableButtonEnhancement>
                            <TableCellLayout
                              media={<MeatBallsMenuIcon />}
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                handlePopoverChange(
                                  item.id,
                                  !popoverStates[item.id]
                                );
                              }}
                            />
                          </PopoverTrigger>
                          <PopoverSurface
                            tabIndex={-1}
                            className="listingPopoverWrapper"
                          >
                            <div className="listingPopoverContent">
                              {getEditPermission("Communication Plan") && (
                                <div
                                  className="popItem"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    handleEdit(item);
                                    handlePopoverChange(
                                      item.id,
                                      !popoverStates[item.id]
                                    );
                                  }}
                                >
                                  <EditIcon />
                                  <p className="text-sm-400 ms-12">Edit</p>
                                </div>
                              )}
                              <div
                                className="popItem"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  handleReminder(item);
                                  handlePopoverChange(
                                    item.id,
                                    !popoverStates[item.id]
                                  );
                                }}
                              >
                                <RemindIcon />
                                <p className="text-sm-400 ms-12">Remind me</p>
                              </div>
                              {getDeletePermission("Communication Plan") && (
                                <div
                                  className="popItem"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    handlePopoverChange(
                                      item.id,
                                      !popoverStates[item.id]
                                    );
                                    handleDelete(item);
                                  }}
                                >
                                  <DeleteIcon />
                                  <p className="text-sm-400 ms-12">Delete</p>
                                </div>
                              )}
                            </div>
                          </PopoverSurface>
                        </Popover>
                      </div>
                    </div>
                  </div>
                );
              case "Sequence #":
                return formatSequenceNumber("CommunicationPlan", item.sequenceNumber);
              case "Client":
                if (parentType === "Client") return null;
                return item.client ? (
                  <span
                    onClick={() => handleClientRedirect(item)}
                    className="text-truncate"
                  >
                    {item.client?.name}
                  </span>
                ) : (
                  ""
                );
              case "Portfolio":
                if (parentType === "Portfolio") return null;
                return item.portfolio ? (
                  <span
                    onClick={() => handlePortfolioRedirect(item)}
                    className="text-truncate"
                  >
                    {item.portfolio?.name}
                  </span>
                ) : (
                  ""
                );
              case "Program":
                if (parentType === "Program") return null;
                return item.program ? (
                  <span
                    onClick={() => handleProgramRedirect(item)}
                    className="text-truncate"
                  >
                    {item.program?.name}
                  </span>
                ) : (
                  ""
                );
              case "Project":
                if (parentType === "Project") return null;
                return (
                  <span
                    onClick={() => handleProjectRedirect(item)}
                    className="text-truncate"
                  >
                    {item.project?.name}
                  </span>
                );
              case "Message":
                return (
                  <Tooltip
                    withArrow
                    positioning="top"
                    content={{
                      children: <>{item.message}</>,
                      className: "ListingTooltip",
                    }}
                    relationship="description"
                  >
                    <div className="text-truncate">{item.message}</div>
                  </Tooltip>
                );
              case "Audience":
                return (
                  <Tooltip
                    withArrow
                    positioning="top"
                    content={{
                      children: <>{item.audience}</>,
                      className: "ListingTooltip",
                    }}
                    relationship="description"
                  >
                    <div className="text-truncate">{item.audience}</div>
                  </Tooltip>
                );
              case "Frequency/When":
                let frequency_when = '-';
                let frequency = "";
                let until = "";
                if (item.isRecurring && item.recurrenceRule) {
                  const rule = item.recurrenceRule;
                  if (rule.includes('FREQ=DAILY')) frequency = 'Daily';
                  else if (rule.includes('FREQ=WEEKLY')) frequency = 'Weekly';
                  else if (rule.includes('FREQ=MONTHLY')) frequency = 'Monthly';
                  else if (rule.includes('FREQ=YEARLY')) frequency = 'Yearly';

                  const untilMatch = rule.match(/UNTIL=([^;]+)/);
                  if (untilMatch) {
                    until = moment.utc(untilMatch[1]).format();
                  }
                }
                const isSameDay = moment.utc(item.startTime).local().isSame(moment.utc(item.endTime).local(), 'day');

                if (item.isAllDay) {
                  if (!isSameDay) {
                    frequency_when = `All day from ${utcToLocalDateString(setting, item.startTime)} to ${utcToLocalDateString(setting, item.endTime)}`
                  }
                  else {
                    frequency_when = `All day on ${utcToLocalDateString(setting, item.startTime)}`
                  }
                }
                else {
                  if (!isSameDay) {
                    frequency_when = `${utcToLocalDateTimeString(setting, item.startTime)} - ${utcToLocalDateTimeString(setting, item.endTime)}`
                  }
                  frequency_when = `${utcToLocalDateString(setting, item.startTime)} ${utcToLocalTimeString(setting, item.startTime)} - ${utcToLocalTimeString(setting, item.endTime)}`

                }


                if (item.isRecurring)
                  frequency_when += ` - Repeats ${frequency.toLowerCase()} ${until && `until ${utcToLocalDateString(setting, until)}`}`

                return (
                  <div className="text-truncate">{`${frequency_when}`}</div>
                );
              case "Medium":
                return (
                  <Tooltip
                    withArrow
                    positioning="top"
                    content={{
                      children: <>{item.medium}</>,
                      className: "ListingTooltip",
                    }}
                    relationship="description"
                  >
                    <div className="text-truncate">{item.medium}</div>
                  </Tooltip>
                );
              case "Source":
                return (
                  <Tooltip
                    withArrow
                    positioning="top"
                    content={{
                      children: <>{item.source}</>,
                      className: "ListingTooltip",
                    }}
                    relationship="description"
                  >
                    <div className="text-truncate">{item.source}</div>
                  </Tooltip>
                );
              case "Expeditor":
                return (
                  <Tooltip
                    withArrow
                    positioning="top"
                    content={{
                      children: <>{item.expeditor}</>,
                      className: "ListingTooltip",
                    }}
                    relationship="description"
                  >
                    <div className="text-truncate">{item.expeditor}</div>
                  </Tooltip>
                );
              case "Status":
                return item.status;
              case "Purpose/Highlights":
                return <TableCellSafeHtml html={item.highlights} />;
              case "Expected Results/ Key Message":
                return <TableCellSafeHtml html={item.results} />;
              case "Category":
                return getLabelByType("communicationCategory", item.category);
              default:
                return cell.getValue();
            }
          },
          Edit: ({ cell, row, table }) => {
            const value =
              editedRows[row.id]?.[cell.column.id] ??
              cell.getValue() ??
              row.original[cell.column.id] ??
              (col.columnType === "select" ? null : "");
            return (
              <EditInput
                label={col.label}
                value={value}
                onChange={(newValue) => {
                  if (row.id.startsWith("mrt-row-create")) {
                    table.setCreatingRow((prev) => ({
                      ...prev,
                      values: {
                        ...prev.values,
                        [cell.column.id]: newValue,
                      },
                    }));
                  } else {
                    setEditedRows((prev) => ({
                      ...prev,
                      [row.id]: {
                        ...prev[row.id],
                        [cell.column.id]: newValue,
                      },
                    }));
                  }
                }}
                onBlur={() => {
                  if (!row.id.startsWith("mrt-row-create")) {
                    const newValue = editedRows[row.id]?.[cell.column.id];
                    table.options.onEditingCellSave?.({
                      cell,
                      value: newValue,
                      row,
                      table,
                    });
                    table.setEditingCell(null);
                  }
                }}
                type={col.columnType}
                dateFormat={
                  col.columnType === "date"
                    ? setting.regionalSettings.dateFormat
                    : null
                }
                clientId={row.original?.client?.id}
                portfolioId={row.original?.portfolio?.id}
                programId={row.original?.program?.id}
                table={table}
              />
            );
          },
          Header: ({ column }) => {
            return editingHeader === column.id ? (
              <input
                value={headerValue}
                onChange={(e) => setHeaderValue(e.target.value)}
                onBlur={() => handleHeaderSave(column.id)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleHeaderSave(column.id);
                  }
                }}
                autoFocus
                className="header-edit-input"
                style={{
                  minWidth: column.getSize() - 60,
                }}
              />
            ) : (
              <span>{column.columnDef.header}</span>
            );
          },
        };
      });
    setCols((prevCols) => {
      if (JSON.stringify(prevCols) !== JSON.stringify(columns)) {
        return columns;
      }
      return prevCols;
    });
  }, [colsList, rowData, editingHeader, headerValue]);

  const table = useMaterialReactTable({
    columns: cols,
    data: rows,
    enableHiding: true,
    enableSorting: true,
    manualSorting: false,
    visibleInShowHideMenu: false,
    enablePagination: false,
    enableTopToolbar: true,
    enableGlobalFilter: true,
    enableStickyHeader: true,
    enableColumnFilterModes: true,
    enableColumnDragging: true,
    enableColumnOrdering: true,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    editDisplayMode: "cell",
    globalFilterFn: "contains",
    enableEditing: false,
    enableFilters: false,
    enableCreatingRow: true,
    createDisplayMode: "row",
    positionCreatingRow: "bottom",
    initialState: {
      density: "compact",
      showGlobalFilter: false,
      showColumnFilters: false,
      enableHiding: false,
      columnOrder: cols.map((col) => col.order),
    },
    state: {
      sorting,
      isLoading: rows.length === 0 && cmPlanLoading,
      columnSizing,
      columnOrder,
      showLoadingOverlay: false,
      showProgressBars: false,
    },
    onSortingChange: setSorting,
    onCreatingRowCancel: () => {
      setValidationErrors({});
      handleCancelAddRow();
    },
    onCreatingRowSave: ({ values, table }) => {
      if (!values.title?.trim()) {
        dispatch(
          generalActions.showToast({
            title: "The Title field is required",
            type: "error",
          })
        );
        return;
      }

      const ClientId = clientId ? clientId : values?.client?.id || null;
      const PortfolioId = projectId ? projectId : values?.project?.id || null;
      const ProgramId = programId ? programId : values?.program?.id || null;
      const ProjectId = projectId ? projectId : values?.project?.id || null;
      if (!ClientId && !ProgramId && !ProjectId) {
        dispatch(
          generalActions.showToast({
            title:
              "Communication Plan must be linked to Client or Program or Project",
            type: "error",
          })
        );
        return;
      }

      const payload = {
        Title: values.title,
        ClientId: ClientId,
        ProgramId: ProgramId,
        PortfolioId: PortfolioId,
        ProjectId: ProjectId,
        Category: values?.category,
        Message: values?.message,
        Audience: values?.audience,
        Time: values?.time,
        Medium: values?.medium,
        Source: values?.source,
        Expeditor: values?.expeditor,
        Status: values?.status,
        Highlights: values?.highlights,
        results: values?.expectedResults,
      };

      handleCreate(payload);
      setValidationErrors({});
      table.setCreatingRow(null);
    },
    onEditingRowCancel: () => {
      setValidationErrors({});
      setEditedRows({});
    },
    positionGlobalFilter: "left",
    onEditingCellSave: ({ cell, row }) => {
      const editedRow = editedRows[row.id];
      const newValue =
        editedRow?.[cell.column.id] !== undefined
          ? editedRow[cell.column.id]
          : cell.getValue();

      if (newValue === cell.getValue()) return; // Skip if no real change
      setRows((prevRows) =>
        prevRows.map((r, index) => {
          if (index === row.index) {
            switch (cell.column.id) {
              case "client":
                return { ...r, client: newValue };
              case "portfolio":
                return { ...r, portfolio: newValue };
              case "program":
                return { ...r, program: newValue };
              case "project":
                return { ...r, project: newValue };
              case "category":
                return { ...r, category: newValue?.id };
              default:
                return { ...r, [cell.column.id]: newValue };
            }
          }
          return r;
        })
      );

      // Remove the specific cell edit
      setEditedRows((prev) => {
        const updated = { ...prev };
        if (updated[row.id]) {
          delete updated[row.id][cell.column.id];
          if (Object.keys(updated[row.id]).length === 0) {
            delete updated[row.id];
          }
        }
        return updated;
      });

      const prePayload =
        cell.column.id === "client"
          ? {
            ...row.original,
            ClientId: newValue?.id,
            portfolioId: row.original.portfolio
              ? row.original.portfolio.id
              : null,
            ProgramId: row.original.program ? row.original.program.id : null,
            ProjectId: row.original.project ? row.original.project.id : null,
          }
          : cell.column.id === "portfolio"
            ? {
              ...row.original,
              ClientId: row.original.client ? row.original.client.id : null,
              portfolioId: newValue?.id,
              ProgramId: row.original.program ? row.original.program.id : null,
              ProjectId: row.original.project ? row.original.project.id : null,
            }
            : cell.column.id === "program"
              ? {
                ...row.original,
                ClientId: row.original.client ? row.original.client.id : null,
                portfolioId: row.original.portfolio
                  ? row.original.portfolio.id
                  : null,
                ProgramId: newValue?.id,
                ProjectId: row.original.project ? row.original.project.id : null,
              }
              : cell.column.id === "project"
                ? {
                  ...row.original,
                  ClientId: row.original.client ? row.original.client.id : null,
                  portfolioId: row.original.portfolio
                    ? row.original.portfolio.id
                    : null,
                  ProgramId: row.original.program ? row.original.program.id : null,
                  ProjectId: newValue?.id,
                }
                : cell.column.id === "category"
                  ? {
                    ...row.original,
                    ClientId: row.original.client ? row.original.client.id : null,
                    portfolioId: row.original.portfolio
                      ? row.original.portfolio.id
                      : null,
                    ProgramId: row.original.program ? row.original.program.id : null,
                    ProjectId: row.original.project ? row.original.project.id : null,
                    category: newValue?.id,
                  }
                  : {
                    ...row.original,
                    [cell.column.id]: newValue,
                    ClientId: row.original.client.id,
                    ProjectId: row.original.project.id,
                  };
      const payload = formatPayload(prePayload);
      handleSave(row.original.id, payload);
    },
    onColumnSizingChange: (updater) => {
      setColumnSizing((prev) => {
        const newSizing =
          typeof updater === "function" ? updater(prev) : updater;
        Object.entries(newSizing).forEach(([columnId, width]) => {
          setColumnWidth(tableName, columnId, width);
        });
        return newSizing;
      });
    },
    onColumnOrderChange: (updater) => {
      const newOrder = typeof updater === "function" ? updater() : updater;
      const neworderList = newOrder
        .filter((item) => item !== "mrt-row-spacer")
        .filter(Boolean);
      const areEqual = compareArrays(neworderList, columnOrder);
      if (areEqual) {
        return newOrder;
      }

      const sortedColumns = sortColumnsByOrderlist(colsList, neworderList);
      handleColumnOrdering(sortedColumns);
      setColumnOrder(neworderList);
      return neworderList;
    },
    muiTableHeadCellProps: ({ column }) => ({
      sx: {
        fontFamily: "Figtree-Medium",
        fontSize: "14px",
        padding: "1rem 0.5rem 1rem 1rem",
        backgroundColor: "#f8f7fc",
        color:"#342c82",
        height: "40px",
        fontWeight: 600,
        "&:hover": {
          backgroundColor: "#ece8fd",
          "& .MuiDivider-root": {
            opacity: 1,
          },
          "& .MuiButtonBase-root": {
            opacity: 1,
          },
          fontWeight: 700,
        },
        position: "relative",
        "& .Mui-TableHeadCell-Content": {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          height: "100%",
        },
        "& .MuiTableSortLabel-root": {
          marginLeft: "8px",
          paddingTop: "3px",
          opacity: 0,
          "&:hover": {
            opacity: 1,
          },
        },
        "& .MuiDivider-root": {
          cursor: "col-resize",
          backgroundColor: "#342C82",
          opacity: 0,
        },
        "& .MuiButtonBase-root": {
          cursor: "grab",
          opacity: 0,
          "& .MuiSvgIcon-root": {
            path:{
              fill: "#342C82"
            }
          }
        },
      },
      onDoubleClick: (e) => {
        e.stopPropagation();
        e.preventDefault();
        handleHeaderDoubleClick(column.id, column.columnDef.header);
      },
    }),
    muiTopToolbarProps: {
      showColumnFilters: false,
      showGlobalFilter: true,
      enableHiding: false,
      sx: {
        position: "sticky",
        top: 0,
        zIndex: 1,
        "& .MuiBox-root": {
          padding: 0,
          display: "flex",
          alignItems: "center",
        },
      },
    },
    renderTopToolbar: () => (
      <ListingHeader
        isHeader={isHeader}
        parentType={parentType ?? "Communications"}
        type="Communication Plan"
        btnLable="Add Communication"
        searchedData={searchHandler}
        setIsCreate={() => setIsCreate(true)}
        rightPane={true}
        clientId={clientId}
        portfolioId={portfolioId}
        programId={programId}
        projectId={projectId}
        isCreatable={true}
        isSearchDisable={cols.length}
        handleCreateFunc={() => {
          handleAddRow();
          table.setCreatingRow(true);
        }}
        isCalendarView={isCalendarView}
        setIsCalendarView={setIsCalendarView}
        triggerSearch={triggerSearch}
      />
    ),
    renderBottomToolbarCustomActions: () => (
      <div className="bottom-toolbar-container">
        <div className="toolbar-content">
          {cmPlanLoading || isFetchingMore ? (
            <div className="loading-indicator">
              <span>{`${!isFetchingMore ? 'Loading...' : 'Loading more data...'}`}</span>
            </div>
          ) : pagination?.TotalCount > 0 ? (
            <div className="data-info">
              <span className="data-text">
                Showing <strong>{rows.length}</strong> of{" "}
                <strong>{pagination?.TotalCount || 0}</strong> total records
              </span>
            </div>
          ) : (
            <div className="data-info">
              <span className="data-text">No records Found</span>
            </div>
          )}
        </div>
      </div>
    ),
    muiBottomToolbarProps: {
      sx: {
        position: "absolute",
        bottom: 0,
        backgroundColor: "#f8f7fc",
        padding: "0.7rem 1rem",
        width: "100%",
        height: "38px",
      },
    },
    muiTableBodyProps: {
      sx: {
        fontFamily: "Figtree-Regular",
        fontSize: "13px",

        marginBottom: "66px",
        "& .MuiTableBody-Cell": {
          "&:hover": {
            backgroundColor: "#ece8fd15",
          },
        },
      },
    },
    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        height: "32px",
        position: "relative",
        "&:hover": {
          backgroundColor: row.original.isSkeleton ? "transparent" : "#ece8fd15",
        },
        cursor: row.original.isSkeleton ? "default" : "pointer",
      },
      className: row.original.isSkeleton ? "" : "hoverable-row",
    }),
    muiTableContainerProps: ({ table }) => ({
      ref: tableContainerRef,
      sx: {
        height: `calc(100% - ${table.refs.topToolbarRef.current?.offsetHeight || parentType
            ? 120
            : 75
          }px)`,
        overflow: "auto",
        "&::-webkit-scrollbar": {
          height: "8px",
          width: "4px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#FFFFFF",
          borderRadius: "8px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#342c82",
          borderRadius: "8px",
          "&:hover": {
            backgroundColor: "#342c82",
          },
        },
      },
    }),
    muiTablePaperProps: {
      sx: {
        height: "100%",
      },
    },
    muiSkeletonProps: {
      height: 34,
      sx: {
        background:
          "linear-gradient(90deg, #e0e0e0 25%, #ECE7FD 50%, #e0e0e0 75%)",
        backgroundSize: "200% 100%",
        animation: "shimmer 1.5s infinite",
        "@keyframes shimmer": {
          "0%": {
            backgroundPosition: "200% 0",
          },
          "100%": {
            backgroundPosition: "-200% 0",
          },
        },
      },
    },
    muiTableBodyCellProps: ({ cell, column, table }) => ({
      sx: {
        fontFamily: "Figtree-Regular",
        fontSize: "13px",
        padding: "0.5rem 1rem",
        position: "relative",
        overflow: "visible",
        "&:focus": {
          outline: "none",
        },
        "&:hover": {
          fontFamily: "Figtree-Medium",
          fontWeight: "bold",
        },
      },
    }),
    renderEmptyRowsFallback: () => {
      return cmPlanLoading ? (
        <div className="d-flex justify-content-center">
          <Spin />
        </div>
      ) : rows.length === 0 ? (
        <div className="flex-grow flex items-center justify-center p-4">
          <div className="h-full flex flex-col items-center justify-center min-h-[400px] p-8">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="65"
              height="64"
              viewBox="0 0 65 64"
              fill="none"
              className="mb-4"
            >
              <path
                d="M6.9002 21.6008C6.9002 16.7407 10.8401 12.8008 15.7002 12.8008H49.3002C54.1603 12.8008 58.1002 16.7407 58.1002 21.6008V42.4008C58.1002 47.2609 54.1603 51.2008 49.3002 51.2008H32.8884L27.8968 46.2092C28.7964 44.3293 29.3002 42.2239 29.3002 40.0008C29.3002 32.0479 22.8531 25.6008 14.9002 25.6008C11.94 25.6008 9.18835 26.494 6.9002 28.0257V21.6008ZM14.9002 51.2008C17.416 51.2008 19.7381 50.3713 21.6079 48.9708L29.7688 57.132C30.3936 57.7569 31.4067 57.7569 32.0315 57.1321C32.6564 56.5072 32.6564 55.4942 32.0316 54.8693L23.8706 46.708C25.2708 44.8384 26.1002 42.5164 26.1002 40.0008C26.1002 33.8152 21.0858 28.8008 14.9002 28.8008C8.71461 28.8008 3.7002 33.8152 3.7002 40.0008C3.7002 46.1864 8.71461 51.2008 14.9002 51.2008ZM14.9002 48.0008C10.4819 48.0008 6.9002 44.4191 6.9002 40.0008C6.9002 35.5825 10.4819 32.0008 14.9002 32.0008C19.3185 32.0008 22.9002 35.5825 22.9002 40.0008C22.9002 44.4191 19.3185 48.0008 14.9002 48.0008Z"
                fill="#342C82"
              />
            </svg>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              No data currently available!
            </h3>
            <p className="text-gray-600 text-center max-w-md">
              New entries will appear here once created.
            </p>
          </div>
        </div>
      ) : null;
    },
    muiLinearProgressProps: {
      sx: {
        height: "4px",
        backgroundColor: "#cfc9ff",
        "& .MuiLinearProgress-bar": {
          backgroundColor: "#342c82",
        },
        "& .MuiLinearProgress-bar1Indeterminate": {
          backgroundColor: "#342c82",
        },
        "& .MuiLinearProgress-bar2Indeterminate": {
          backgroundColor: "#342c82",
        },
        "& .MuiLinearProgress-barColorPrimary": {
          backgroundColor: "#342c82",
        },
        "& .MuiLinearProgress-colorPrimary": {
          backgroundColor: "#cfc9ff",
        },
        "& .MuiLinearProgress-colorSecondary": {
          backgroundColor: "#cfc9ff",
        },
        "& .MuiLinearProgress-barColorSecondary": {
          backgroundColor: "#342c82",
        },
      },
    },
  });

  return <MaterialReactTable table={table} />;
};

export default CommunicationPlanTable;
